import React from 'react'
import PageHeader from '../../layout/PageHeader';
export default function Cookies() {
    return (
        <div id="main">
            <PageHeader title="Cookie Policy" ></PageHeader>
        </div>
    )
}
